import * as types from '../../constants/log/itemBoxLogConstants';

export const itemBoxLogListRequest = (
    {
        page,
        pageLength,
        beginDate,
        endDate,
        account,
        callback,
        error
    }
) => ({
    type: types.ITEM_BOX_LOG_LIST_REQUEST,
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    callback,
    error
});

export const itemBoxLogList = (list) => ({
    type: types.ITEM_BOX_LOG_LIST,
    list,
});

export const setTotalCount = (totalCount) => ({
    type: types.SET_TOTAL_COUNT,
    totalCount,
});

export const setItemBoxLogPagination = (
    page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
    type: types.SET_ITEM_BOX_LOG_PAGINATION,
    page,
    totalCount,
    beginDate,
    endDate,
    searchCode,
    searchString,
});
